type SearchOverFields<T> = Partial<
  Record<keyof T, { value: string; cop: string[]; op?: string }>
>[];

/**
 * Get search over fields for the given search value and keys
 *
 * example: getSearchOverFields<Customer>('John', ['first_name', 'last_name']);
 *
 * expected output:
 *
 * ```ts
 * [
 *    {
 *      first_name: {
 *        value: 'John',
 *        cop: ['ilike']
 *      }
 *    },
 *    {
 *      last_name: {
 *        value: 'John',
 *        cop: ['ilike'],
 *        op: 'or'
 *      }
 *    }
 * ]
 * ```
 */
const getSearchOverFields = <T>(
  searchValue: string,
  keys: (keyof T)[],
): SearchOverFields<T> => {
  return keys.map((key, index) => ({
    [key]: {
      value: searchValue,
      cop: ['ilike'],
      ...(index > 0 ? { op: 'or' } : {}),
    },
  })) as SearchOverFields<T>;
};

export default getSearchOverFields;
